module.exports = __webpack_public_path__ + "img/pantalla-9-5.6844e0c8.png";